module.exports = __webpack_public_path__ + "img/module-dependents.a9419998.svg";